import * as apiActions from "@configuratorware/configurator-frontendgui/App/Reducers/Actions";
import { fetchConfigurationByCode as baseFetchConfigurationByCode }  from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions";
import Api from "@configuratorware/configurator-frontendgui/Framework/Api";
import { clearBasket, receiveBasket } from "../Basket/Actions";

export const actions = {
  RECEIVE_LOGIN: "RECEIVE_LOGIN",
  SET_LOGOFF: "SET_LOGOFF",
  RECEIVE_SKISCHOOLS: "RECEIVE_SKISCHOOLS",
  SET_SELECTED_SKISCHOOL: "SET_SELECTED_SKISCHOOL",
  RECEIVE_RETAILERS: "RECEIVE_RETAILERS",
  SET_LOGIN_ERROR: "SET_LOGIN_ERROR"
};

export const receiveLogin = (data: any) => (dispatch, getState)  => {
  data && data.token && Api.setTokenHeader(data.token);
  return dispatch({
  type: actions.RECEIVE_LOGIN,
  data,
})};

export const setLogOff = () => (dispatch, getState)  => {
  // clearing user token from headers
  Api.setTokenHeader('');
  dispatch(clearBasket());
  return dispatch({
    type: actions.SET_LOGOFF,
  });
}

export const postLoginData = (username: string, password: string) => {
  const formData = new FormData();
  formData.append("_username", username);
  formData.append("_password", password);
  return apiActions.postData(
    "login_check",
    formData,
    receiveLogin
  );
};

export const fetchSkiSchools = () => async (dispatch, getState)=> {
  const token = getState().login.token;
  token && Api.setTokenHeader(token);
  return dispatch(apiActions.fetchData('user/skischools', receiveSkiSchools));
}

export const receiveRetailers = (data) => ({
  type: actions.RECEIVE_RETAILERS,
  data,
});

export const fetchRetailers = () => {
  return apiActions.fetchData('retailer', receiveRetailers);
}

export const setSelectedSkiSchool = (skischool) => (dispatch, getState) => {
  const uuid = getState().basket.uuid;
  dispatch(apiActions.postData(`basket/save-to-user?school_id=${skischool.id}&uuid=${uuid}`, null, receiveBasket));
  const { hasNoAccess, loadCode } = getState().configurator;
    if (hasNoAccess && loadCode) {
      dispatch(baseFetchConfigurationByCode(loadCode));
    }
  return dispatch({
    type: actions.SET_SELECTED_SKISCHOOL,
    skischool,
  });
};

export const receiveSkiSchools = (data) => (dispatch, getState) => {
  if(data.code === 401) {
    return dispatch(setLogOff())
  }
  return dispatch({
  type: actions.RECEIVE_SKISCHOOLS,
  data,
});
}

export const setLoginError = (hasError) => ({
  type: actions.SET_LOGIN_ERROR,
  hasError
})